const InvoiceWithTokenSkeleton = () => {
  return (
    <div className="h-dvh w-dvw overflow-hidden bg-[linear-gradient(180deg,#F0F9FF_0%,#B9E6FE_100%)] p-10">
      <div className="relative flex h-full flex-col rounded-xl bg-white shadow-[0px_0px_8px_rgba(65,70,81,0.1)]">
        <div className="mb-20 flex flex-1 flex-col overflow-y-auto">
          <div className="hidden max-h-[198px] min-h-[148px] justify-between rounded-t-xl border-0 border-b border-solid border-b-neutral-200 bg-neutral-50 sm:flex">
            <div className="flex flex-col gap-3 px-6 pb-3 pt-6">
              <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-[90px] w-[200px] animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="flex max-w-[50%] flex-1 flex-col items-end justify-center gap-2 border-0 border-l border-solid border-l-neutral-200 p-6">
              <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-40 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-36 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>

          <div className="flex h-fit min-h-[148px] flex-col justify-between rounded-t-xl border-0 border-b border-solid border-b-neutral-200 bg-neutral-50 sm:hidden">
            <div className="flex flex-col gap-3 px-4 pb-2 pt-4 sm:px-2">
              <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-[40px] w-[108px] animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="flex flex-1 flex-col justify-center gap-2 border-0 border-l border-solid border-l-neutral-200 p-4 sm:px-2">
              <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-36 animate-pulse rounded bg-neutral-200" />
              <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>

          <div className="flex min-h-fit px-6 py-3 sm:px-2">
            <div className="flex flex-1 flex-col gap-2">
              <div className="h-3 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-40 animate-pulse rounded bg-neutral-200" />
              <div className="flex flex-row flex-wrap items-center gap-1">
                <div className="h-3 w-12 animate-pulse rounded bg-neutral-200" />
                <div className="h-2 w-2 rounded-full bg-neutral-200" />
                <div className="h-3 w-20 animate-pulse rounded bg-neutral-200" />
                <div className="h-3 w-16 animate-pulse rounded bg-neutral-200" />
                <div className="h-2 w-2 rounded-full bg-neutral-200" />
                <div className="h-3 w-12 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="h-3 w-48 animate-pulse rounded bg-neutral-200" />
              <div className="h-3 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-3 w-40 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="flex flex-col items-end gap-3">
              <div className="flex flex-col items-end gap-1">
                <div className="h-3 w-20 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="flex flex-col items-end gap-1">
                <div className="h-3 w-24 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="flex flex-col items-end gap-1">
                <div className="h-3 w-20 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="flex flex-col items-start gap-4 rounded-none border-0 border-t border-dashed border-t-neutral-300 px-6 py-5 sm:px-2">
              <div className="flex w-full items-start justify-between gap-2">
                <div className="h-6 w-24 animate-pulse rounded bg-neutral-200 sm:h-4 sm:w-20" />
                <div className="h-6 w-16 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="flex w-full items-start justify-between gap-3 sm:items-end">
                <div className="flex flex-wrap items-center gap-2 sm:flex-col sm:items-start">
                  <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
                  <div className="h-2 w-2 rounded-full bg-neutral-200 sm:hidden" />
                  <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
                  <div className="h-2 w-2 rounded-full bg-neutral-200 sm:hidden" />
                  <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
                  <div className="h-2 w-2 rounded-full bg-neutral-200 sm:hidden" />
                  <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
                </div>
                <div className="flex flex-col items-end gap-1">
                  <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
                  <div className="h-10 w-32 animate-pulse rounded bg-neutral-200 sm:h-9 sm:w-28" />
                </div>
              </div>
            </div>

            <div className="flex justify-between gap-3 border-0 border-y border-solid border-neutral-200 px-6 py-3 sm:flex-col sm:px-2">
              <div className="flex flex-col gap-2">
                <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-36 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="flex items-start gap-1.5">
                <div className="h-5 w-10 animate-pulse rounded-full bg-neutral-200" />
                <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
              </div>
            </div>

            <div className="flex flex-col gap-2 rounded-none bg-neutral-50 px-6 py-3">
              <div className="flex flex-col gap-1">
                <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-full animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-3/4 animate-pulse rounded bg-neutral-200" />
              </div>
              <div className="flex flex-col">
                <div className="h-4 w-full animate-pulse rounded bg-neutral-200" />
                <div className="h-4 w-5/6 animate-pulse rounded bg-neutral-200" />
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 flex flex-col items-end justify-center gap-2 border-0 border-t border-solid border-t-neutral-200 bg-white px-8 py-4">
          <div className="h-10 w-32 animate-pulse rounded bg-neutral-200 sm:h-8 sm:w-28" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceWithTokenSkeleton;
